import { Guid } from './Guid';

export async function _http(
  url: string | Request,
  token?: string,
  body?: string,
  method: string = 'GET',
  headers?: { [key: string]: string }
): Promise<Response> {
  var opts: RequestInit = {};

  //As per internal discussions, changing it to new guid for each request.
  headers = { 'x-ms-correlation-id': Guid.newGuid(), ...headers };

  opts.headers = { ...headers, Authorization: `${token}` };
  opts.method = method;
  opts.mode = 'cors';

  if (body) {
    opts.body = body;
  }

  if (method.toLowerCase() === 'post') {
    opts.headers = {
      ...opts.headers,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    };
  }

  var response: Response = await fetch(url, opts);

  return response;
}
